<template>
    <div id="cuntry">
        <div class="opera_img" id="serchFixed">
            <div class="opera_title">
                <div class="opearbt">城市智慧停车运营</div>
                <div class="operatext" style="width:560px;white-space: normal;line-height:1.6;text-align:justify;">
                    城市智慧停车运营产品为面向城市停车运营管理和车主服务推出的整体信 息化产品。通过物联设备采集城市的停车位数据，实现状态监控、停车位查 找、充值及缴费、可视化运营、执法监管等，让人、车、泊位三位一体智慧化管理。
                </div>
            </div>
        </div>
        <div>
            <el-tabs v-scroll v-model="active" @tab-click="handleClick">
                <!-- <el-tab-pane label="城市智慧停车运营管理平台" name="4">
                </el-tab-pane> -->
                <el-tab-pane name="5" label="城市道路停车收费巡检管理软件">
                    <div class="introduce">
                        <div class="intro_auto">
                            <div class="prointo">产品介绍</div>
                            <div class="proflex">
                                <div class="daolu">
                                    <div>
                                        <div class="ruanJ">城市道路停车收费管理软件</div>
                                        <div class="ruanJ_p">
                                            <p>城市道路停车收费管理软件是专用于执行停车收费管理工作的产品，可有效监管泊位信息，</p>
                                            <p class="textpadd">自动计时计费，完成订单的结算。此产品克服了人工记录的低效管理方式，可以减少在停车</p>
                                            <p class="textpadd">收费管理工作过程中的人工干预行为。</p>
                                        </div>
                                    </div>
                                    <div class="ruan_flex">
                                        <div class="yuan">
                                            <div class="qD_img"></div>
                                        </div>
                                        <div class="ruan_mar">签到签出、人员考勤</div>
                                    </div>
                                    <div class="ruan_flex flextwo">
                                        <div class="yuan">
                                            <div class="boW_img"></div>
                                        </div>
                                        <div class="ruan_mar">泊位监管、订单查询</div>
                                    </div>
                                    <div class="ruan_flex flextwo">
                                        <div class="yuan">
                                            <div class="shenQ_img"></div>
                                        </div>
                                        <div class="ruan_mar">停车申请、订单结算</div>
                                    </div>
                                    <div class="ruan_flex flextwo">
                                        <div class="yuan">
                                            <div class="qianF_img"></div>
                                        </div>
                                        <div class="ruan_mar">线上缴费、欠费补缴</div>
                                    </div>
                                </div>
                                <div class="chanpin_cuntry"></div>
                            </div>
                        </div>
                    </div>
                    <div class="function">
                        <div class="funauto">
                            <div class="profun">城市道路停车巡检管理软件</div>
                            <div class="cuntry_tyext">
                                <p>城市道路停车巡检管理软件是给稽查人员用于监管停车资源的产品，实现对现场设备、泊位、网络、业务异常的巡检工作，保证业务正常有效地</p>
                                <p class="textpadd">运转，使异常问题及时有效解决，提高工作的效率。</p>
                            </div>
                            <div class="cuntry_flex">
                                <div class="width_cuntry">
                                    <div class="flex_div">
                                        <div class="renyuan"></div>
                                        <div class="CfX Cfxleft_mar">
                                            <div class="center_text">签到签出、人员考勤</div>
                                        </div>
                                    </div>
                                    <div class="flex_div flex_mar">
                                        <div class="renwu"></div>
                                        <div class="CfX Cfxleft_mar">
                                            <div class="center_text">任务调度、巡检定位</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="second_cuntry">
                                </div>
                                <div class="cuntry_div">
                                    <div class="flex_div">
                                        <div class="CfX Cfxrig_mar">
                                            <div class="center_text">泊位监管、执法取证</div>
                                        </div>
                                        <div class="jianguan"></div>
                                    </div>
                                    <div class="flex_div flex_divmar">
                                        <div class="CfX Cfxrig_mar">
                                            <div class="center_text">设备维保、排班查询</div>
                                        </div>
                                        <div class="shebei"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="advantage">
                        <div class="vantaauto">
                            <div class="vautatitle">产品优势</div>
                            <div class="vautaflex">
                                <div class="vanta">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/Inspection/chengbendilian.png" />
                                    </div>
                                    <div class="vancenter vantext">成本低廉</div>
                                    <div class="van_pt">
                                        <p>投资少，建设周期短，维护</p>
                                        <p class="textpadd">成本低</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/Inspection/yunduantongbu.png" />
                                    </div>
                                    <div class="vancenter vantext">云端同步</div>
                                    <div class="van_pt">
                                        <p>云平台提供交易订单分析汇</p>
                                        <p class="textpadd">总和对账功能等</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/Inspection/renyuanjianguan.png" />
                                    </div>
                                    <div class="vancenter vantext">人员监管</div>
                                    <div class="van_pt">
                                        <p>人员考勤监管可视化，直观</p>
                                        <p class="textpadd">展示人员轨迹</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/Inspection/caozuojiandan.png" />
                                    </div>
                                    <div class="vancenter vantext">操作简单</div>
                                    <div class="van_pt">
                                        <p>车牌自动识别，软件操作简</p>
                                        <p class="textpadd">单、效率高</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="6" label="市民车主停车服务应用">
                    <div class="introduce">
                        <div class="intro_auto">
                            <div class="prointo">产品介绍</div>
                            <div class="proflex">
                                <div class="width_576">
                                    <div class="jituan">市民车主停车服务应用软件</div>
                                    <div class="jituan_text">
                                        <p>市民车主停车服务应用软件是连接城市停车服务与市民车主载体，涵</p>
                                        <p>盖了微信公众号、微信小程序、手机APP、支付宝服务窗等多种产品</p>
                                        <p>形态，车主可以通过任意一种产品使用城市停车资源查询、停车诱</p>
                                        <p>导、停车登记、记录查询、在线缴费等服务。此外，还能以市民车主</p>
                                        <p>停车服务应用软件为入口，围绕车辆与车主提供丰富的汽车增值服</p>
                                        <p>务，提升城市的停车体验。</p>
                                    </div>
                                </div>
                                <div class="width_576 pro_jiazhi">
                                    <div class="proValue">产品价值</div>
                                    <div class="proimage">
                                        <ul>
                                            <li>服务车主，提升城市停车体验</li>
                                            <li>信息共享，减少车主找位时间</li>
                                            <li>自主缴费，降低缴费等待时间</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="function_cuntry">
                        <div class="funauto">
                            <div class="profun_name">产品功能</div>
                            <div class="procuntry">
                            </div>
                            <div class="cuntryflex_div">
                                <div class="content_flexdiv">车主服务APP</div>
                                <div class="content_flexdiv content_pad">微信公众号</div>
                                <div class="content_flexdiv content_pad">微信小程序</div>
                                <div class="content_flexdiv content_pad">支付宝生活号</div>
                            </div>
                            <div class="carCx">
                                <div class="Cx_width">
                                    <div class="Cx_flex">
                                        <div class="carCx_yuan"></div>
                                        <div class="carCx_title">车位查询</div>
                                    </div>
                                    <div class="carCx_text">
                                        <p>查看路内停车与路外停车场的位置、</p>
                                        <p class="textpadd">剩余泊位数和停车收费标准，帮助车</p>
                                        <p class="textpadd">主寻找最佳的停车地点。</p>
                                    </div>
                                </div>
                                <div class="Cx_border"></div>
                                <div class="Cx_width Cx_pad">
                                    <div class="Cx_flex">
                                        <div class="carCx_yuan"></div>
                                        <div class="carCx_title">实时计费</div>
                                    </div>
                                    <div class="carCx_text">
                                        <p>停车后，可实时查看停车计时与计</p>
                                        <p class="textpadd">费信息，车主可随时随地掌握自己</p>
                                        <p class="textpadd">的停车和计费信息。</p>
                                    </div>
                                </div>
                                <div class="Cx_border"></div>
                                <div class="Cx_width Cx_pad">
                                    <div class="Cx_flex">
                                        <div class="carCx_yuan"></div>
                                        <div class="carCx_title">在线缴费</div>
                                    </div>
                                    <div class="carCx_text">
                                        <p>车主可通过微信、支付宝等支付渠道</p>
                                        <p class="textpadd">缴纳停车费，同时也支持无感支付，</p>
                                        <p class="textpadd">简化车主缴费流程，提升停车体验。</p>
                                    </div>
                                </div>
                                <div class="Cx_border Cx_bormar"></div>
                                <div class="Cx_width Cx_pad">
                                    <div class="Cx_flex">
                                        <div class="carCx_yuan"></div>
                                        <div class="carCx_title">电子发票</div>
                                    </div>
                                    <div class="carCx_text">
                                        <p>车主可在软件终端中自助申请停车</p>
                                        <p class="textpadd">发票，并且支持电子发票，极大的</p>
                                        <p class="textpadd">减少了车主的开票步骤。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="advantage">
                        <div class="vantaauto">
                            <div class="vautatitle">产品优势</div>
                            <div class="vautaflex">
                                <div class="vanta">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/Inspection/fuwuwending.png" />
                                    </div>
                                    <div class="vancenter vantext">服务稳定</div>
                                    <div class="van_p">
                                        <p class="text_center">停车服务全天候无故障运行</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/Inspection/hailliangyonghu.png" />
                                    </div>
                                    <div class="vancenter vantext">海量用户支持</div>
                                    <div class="van_p">
                                        <p>支持百万级的用户访问</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/Inspection/xingtaifengfu.png" />
                                    </div>
                                    <div class="vancenter vantext">形态丰富</div>
                                    <div class="van_p" style="text-align:left;margin-left: 32px;">
                                        <p>支持微信、支付宝、Android、iOS</p>
                                        <p class="textpadd">等多种产品形态</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/Inspection/fuwukuozhang.png" />
                                    </div>
                                    <div class="vancenter vantext">服务扩展</div>
                                    <div class="van_p">
                                        <p>可扩展停车相关的增值服务内容</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>

</template>
<script>
export default {
  data() {
    return {
      active: '',
    };
  },
  watch: {
    $route(route) {
      this.active = route.query.active;
      if (this.$route.query.active == '5') {
        document.title = '城市道路停车收费巡检管理软件';
      } else if (this.$route.query.active == '6') {
        document.title = '市民车主停车服务应用';
      } else if (this.$route.query.active == '4') {
        document.title = '城市智慧停车运营管理平台';
      }
    },
  },
  created() {
    this.$route.query.active = '5';
    document.title = '城市道路停车收费巡检管理软件';
    this.active = this.$route.query.active;
  },
  methods: {
    handleClick(tab, event) {
      window.scrollTo(0, 0);
      if (tab.name == '4') {
        document.title = '城市智慧停车运营管理平台';
      } else if (tab.name == '5') {
        document.title = '城市道路停车收费巡检管理软件';
      } else if (tab.name == '6') {
        document.title = '市民车主停车服务应用';
      }
    },
  },
};
</script>
<style lang='scss'>
@import '../../../common/css/base';
@import 'cuntry';
</style>
